// configContext.js
import React, { createContext, useContext, useEffect } from "react";

const ConfigContext = createContext(null);

export const ConfigProvider = ({ config, children }) => {
  useEffect(() => {
    if (config?.NMGOPS_URL) {
      localStorage.setItem("redirect_url", config.NMGOPS_URL);
    }
  }, [config?.NMGOPS_URL]);

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
